export const VIEW_TAB_TEST_ID_PREFIX = 'view-tab-'
